module.exports = __webpack_public_path__ + "static/tactics_collection_basket-65dc7e0f528e0c934c95c816a443d63b.mp4";